"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useImageReloader = void 0;
const react_1 = require("react");
function useImageReloader() {
    const maxAttempts = 10;
    const timersRef = (0, react_1.useRef)([]);
    const unmountedRef = (0, react_1.useRef)(false);
    const [error, setError] = (0, react_1.useState)();
    const handleImageError = (imageEl) => {
        // if successful, skip
        // NOTE: taken from https://stackoverflow.com/a/1977898/7013346
        if (imageEl.complete && imageEl.naturalWidth !== 0) {
            return;
        }
        let tryCount = 0;
        let didLoad = false;
        imageEl.onload = () => {
            didLoad = true;
        };
        imageEl.onerror = () => {
            // reload image after a second
            const reload = setTimeout(() => {
                // after maxAttempts, stop trying and show error if failed
                if (tryCount >= maxAttempts) {
                    if (!didLoad && !unmountedRef.current) {
                        setError('Unable to load image.');
                    }
                    return;
                }
                tryCount++;
                // set image src to reload image
                // NOTE: taken from https://stackoverflow.com/a/55499609/7013346
                const { src = '' } = imageEl;
                imageEl.src = src;
                console.log('[image-reloader]. Reload attempt: %o Image: %o', tryCount, src);
            }, 1000);
            timersRef.current.push(reload);
        };
    };
    const reloadFailedImages = (iframe) => {
        const doc = iframe === null || iframe === void 0 ? void 0 : iframe.contentDocument;
        if (!doc) {
            return;
        }
        setError(undefined);
        // console.log('InputHtml: reloadFailedImages');
        Array.from(doc.querySelectorAll('img')).forEach(handleImageError);
    };
    (0, react_1.useEffect)(() => {
        return () => {
            // clear all timers
            unmountedRef.current = true;
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const timers = timersRef.current;
            timers.splice(0, timers.length).forEach(clearTimeout);
        };
    }, []);
    return { error, reloadFailedImages };
}
exports.useImageReloader = useImageReloader;
//# sourceMappingURL=useImageReloader.js.map